const state = {
  pago_data: [],
};
export default state;
